import { defineTool } from '@/shell/tool';

/**
 * Tutor Payments (Flutter `/tutor-payment`).
 *
 * The only tool here with two grants (`tutor-payments-is-a-tool` D3): `:use` opens it and draws
 * the figures, `:pay` is every act whose consequence leaves the browser — the bank batch, the
 * payslips, and marking a tutor or a window paid or unpaid. Hiding is convenience; tutoring
 * refuses what the caller's grants do not hold (A4).
 */
export default defineTool({
  id: 'tutor-payments',
  title: 'Tutor Payments',
  summary:
    'Read and settle what each tutor is owed for the lessons they taught.',
  section: 'operations',
  order: 20,
  icon: 'monetization_on',
  owner: '@Drabu',
  permission: 'tutor-payments:use',
  grants: ['tutor-payments:pay'],
  routes: () => import('./TutorPaymentsPage'),
});
